import React, {useState, useEffect, useMemo, useRef} from "react";
import { TrendsLineWithMetrics } from "../../layouts/ChartLayout";
import server from "../../../api/server";
import "../../../dashboard-components/loader.css"
import { FaTimes } from "react-icons/fa";
import { Download, ArrowUp, ArrowDown, ChevronsUpDown } from "lucide-react";
import ModernTimeDropdown from "../../layouts/modernDropdown";
import ModernDateRangePicker from "../../layouts/ModernDateRangePicker";
import ConversationRecords from "../calls/ConversationRecords.jsx";
import CustomerRecords from "../customers/CustomerRecords.jsx";
import { useNavigate, useLocation } from 'react-router-dom';
import { initializeFiltersFromUrl, updateUrlWithFilters } from '../../../utils/filterUtils';

const ConcernQueries = ({serviceID, clientID}) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Default filter values
    const defaultFilters = {
            team_name: '',
      time: 'Last 7 Days',
      audioduration: '',
      audioDurationLower: '',
      audioDurationUpper: '',
      customRangeType: 'between',
    };

    const CONCERNS_QUICK_FILTER_KEYS = Object.keys(defaultFilters);
    const DRILLDOWN_ONLY_FILTER_KEYS = [
      'lastinteraction',
      'lastinteraction_range_type',
      'Last Interaction Start',
      'Last Interaction End',
      'firstinteraction',
      'firstinteraction_range_type',
      'First Interaction Start',
      'First Interaction End',
      'openConcerns',
      'concernSubcategory',
      'concernCategory',
      'querySubcategory',
      'queryCategory',
      'customStart',
      'customEnd',
    ];

    const pickConcernsQuickFilters = (filterState) =>
      CONCERNS_QUICK_FILTER_KEYS.reduce((acc, key) => {
        if (filterState[key] !== undefined) acc[key] = filterState[key];
        return acc;
      }, {});

    const stripDrilldownFilterKeys = (filterState) => ({
      ...defaultFilters,
      ...pickConcernsQuickFilters(filterState),
    });

    const buildCustomerDrilldownFilters = (filterState, start, end, { openConcerns } = {}) => {
      const applied = pickConcernsQuickFilters(filterState);
      if (start && (filterState.customRangeType === 'after' || end)) {
        applied.lastinteraction = 'Custom Range';
        applied.lastinteraction_range_type = filterState.customRangeType || 'between';
        applied['Last Interaction Start'] = start;
        if (end) applied['Last Interaction End'] = end;
      }
      if (openConcerns !== undefined) {
        applied.openConcerns = openConcerns;
      }
      return applied;
    };

    // Initialize filters from URL or use defaults
    const initialFilterState = initializeFiltersFromUrl(location, defaultFilters, {});

    const [service_id, setService_id] = useState(null)
    const [client_id, setClient_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [customStart, setCustomStart] = useState(initialFilterState.customStart || '')
    const [customEnd, setCustomEnd] = useState(initialFilterState.customEnd || '')
    const [isLoading, setIsLoading] = useState(false)
    const [allmetrics, setallMetrics] = useState(null)
    const [dailyTrendData, setDailyTrendData] = useState(null)
    const [topConcerns, setTopConcerns] = useState([])
    const [topQueries, setTopQueries] = useState([])
  const [concernsSortConfig, setConcernsSortConfig] = useState({ field: null, direction: null })
  const [queriesSortConfig, setQueriesSortConfig] = useState({ field: null, direction: null })
    const [showConversationPage, setShowConversationPage] = useState(false)
    const [showCustomerPage, setShowCustomerPage] = useState(false)
    const [selectedSegment, setSelectedSegment] = useState(null)
    const [showDetails, setShowDetails] = useState(false)
    const [activeMetric, setActiveMetric] = useState(null)
    const [data] = useState([
            {
              date: '2025-01-01',
              calls: 120,
              agentScore: 6.2,
              needsReview: 15,
              fatalCalls: 3,
              aht: 133 // in seconds
            },
            {
              date: '2025-01-15',
              calls: 135,
              agentScore: 6.3,
              needsReview: 14,
              fatalCalls: 2,
              aht: 145
            },
            {
              date: '2025-02-01',
              calls: 142,
              agentScore: 6.5,
              needsReview: 12,
              fatalCalls: 2,
              aht: 139
            },
            {
              date: '2025-02-15',
              calls: 128,
              agentScore: 6.2,
              needsReview: 16,
              fatalCalls: 4,
              aht: 151
            },
            {
              date: '2025-03-01',
              calls: 138,
              agentScore: 6.4,
              needsReview: 13,
              fatalCalls: 3,
              aht: 140
            },
            {
              date: '2025-03-15',
              calls: 145,
              agentScore: 6.7,
              needsReview: 10,
              fatalCalls: 2,
              aht: 133
            }
          ]);
          const [role] = useState(()=> {
            const userCookie = getCookie('dashboard_login_user_creds');
            if (userCookie) {
              const userData = JSON.parse(userCookie);
              const role = userData.role
              return role
            }
            return 'admin';
          })
    
          const [filters, setFilters] = useState(initialFilterState.filters);
            const [dummyFilterData, setDummyFilterData] = useState({
                employees: [],
                times: ['Today',
                  'Yesterday',
                  'This Week',
                  "This Month",
                  "Last Month",
                  "Last 7 Days",
                  "Last 30 Days",
                  "Last 3 Months",
                  "Custom Range"],
                audio_duration: ['Less than 1 Minute', '1-2 Minutes', '3-5 Minutes', 'Above 2 Minutes','More than 5 Minutes', 'Custom Range']
              });
              const [multiSelectFields, setMultiSelectFields] = useState([]);
              const isMultiSelectField = (key) => Array.isArray(multiSelectFields) && multiSelectFields.includes(key);
              const metricsDebounceRef = useRef(null);
              const firstMetricsLoadRef = useRef(true);
              const handleFilterChange = (e, key) => {
                const rawValue = e.target.value;
                const value = isMultiSelectField(key)
                  ? (Array.isArray(rawValue) ? rawValue : (rawValue ? [rawValue] : []))
                  : rawValue;
                
                // If changing time filter and it's not "Custom Range", clear the custom date values
                if (key === 'time' && !Array.isArray(value) && value !== 'Custom Range') {
                  setFilters((prev) => ({ 
                    ...prev, 
                    [key]: value,
                    customRangeType: 'between',
                  }));
                  setCustomStart('');
                  setCustomEnd('');
                } else if (key === 'audioduration' && !Array.isArray(value) && value !== 'Custom Range') {
                  setFilters((prev) => ({
                    ...prev,
                    [key]: value,
                    audioDurationLower: '',
                    audioDurationUpper: '',
                  }));
                } else {
                  setFilters((prev) => ({ ...prev, [key]: value }));
                }
              };
    const getAudioDurationValueForApi = () => {
      if (filters.audioduration !== 'Custom Range') return filters.audioduration;
      if (filters.audioDurationLower === '' || filters.audioDurationUpper === '') return '';
      const lower = Number(filters.audioDurationLower);
      const upper = Number(filters.audioDurationUpper);
      if (Number.isNaN(lower) || Number.isNaN(upper) || lower < 0 || upper < 0 || lower > upper) return '';
      return `${lower}-${upper}`;
    };
        
          // Calculate percentage changes
          const calculatePercentChange = (metric) => {
            const currentValue = data[data.length - 1][metric];
            const previousValue = data[data.length - 2][metric];
            return ((currentValue - previousValue) / previousValue * 100).toFixed(1);
          };
        
          // Format date for the x-axis
          const formatDate = (dateStr) => {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          };
        
          // Format time (seconds to mm:ss)
          const formatTime = (seconds) => {
            const mins = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${mins}:${secs.toString().padStart(2, '0')}`;
          };
    const transformMetrics = (data) => {
      const lastData = data['last_current_period'];
      const prevData = data['percentage_change']
        return [
            {
              id: 'customers',
              title: '#Customers',
              value: lastData.customers,
              change: prevData.customers,
              color: '#4F46E5',
              allowVisit: true,
              formatter: (value) => value
            },
            {
                id: 'open_concerns_and_queries',
                title: '#Open Concerns & Queries',
                value: lastData.open_concerns_and_queries,
                change: prevData.open_concerns_and_queries,
                color: '#4F46E5',
                allowVisit: true,
                formatter: (value) => value
            }
        ]
    }
    const handleDownloadCSV = (type) => {
      // Determine which dataset to use
      const data = type === 'queries' ? topQueries : topConcerns;
      
      if (!data || data.length === 0) {
        console.error(`No data available for ${type}`);
        return;
      }
      
      // Get all possible headers from the objects
      const headers = Array.from(
        new Set(
          data.flatMap(item => Object.keys(item))
        )
      );
      
      // Create CSV content
      // First add the headers
      let csvContent = headers.join(',') + '\n';
      
      // Add each row of data
      data.forEach(item => {
        const row = headers.map(header => {
          // Handle missing values, quotes in strings, and format properly for CSV
          const value = item[header] === undefined ? '' : item[header];
          // Properly escape values that contain commas or quotes
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csvContent += row.join(',') + '\n';
      });
      
      // Create a Blob with the CSV content
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
      // Create a download link and trigger the download
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const fileName = `${type}_${new Date().toISOString().slice(0, 10)}.csv`;
      
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the URL object
      URL.revokeObjectURL(url);
    };
    const handleConcernSubcategoryClick = (type, category) => {
      let obj = {}
    obj['filter_applied'] = {...filters};
    if (customStart && (filters.customRangeType === "after" || customEnd)) {
      obj['filter_applied']['customStart'] = customStart
      obj['filter_applied']['customRangeType'] = filters.customRangeType || "between"
      if (customEnd) obj['filter_applied']['customEnd'] = customEnd
    }
    obj['filter_applied']['concernSubcategory'] = type
    obj['filter_applied']['concernCategory'] = category
    setSelectedSegment(obj)
    setShowConversationPage(true)
  }
  const handleQuerySubcategoryClick = (type, category) => {
    let obj = {}
    obj['filter_applied'] = {...filters};
    if (customStart && (filters.customRangeType === "after" || customEnd)) {
      obj['filter_applied']['customStart'] = customStart
      obj['filter_applied']['customRangeType'] = filters.customRangeType || "between"
      if (customEnd) obj['filter_applied']['customEnd'] = customEnd
    }
    obj['filter_applied']['querySubcategory'] = type
    obj['filter_applied']['queryCategory'] = category
    setSelectedSegment(obj)
    setShowConversationPage(true)
  }
  const handleShowCustomers = (data) => {
    if (data.id === 'customers') {
      data.type = 'customer_records';
      data.filter_applied = buildCustomerDrilldownFilters(filters, customStart, customEnd, { openConcerns: null });
    } else {
      data.type = 'open_concerns_and_queries';
      data.filter_applied = buildCustomerDrilldownFilters(filters, customStart, customEnd, { openConcerns: 'Yes' });
    }
    setSelectedSegment(data);
    setShowCustomerPage(true);
  }
    const getMetrics = async () => {
      if (
        filters.time === 'Custom Range' &&
        (customStart === '' || (filters.customRangeType !== "after" && customEnd === ''))
      ) {
        return;
      }
        try {
            setIsLoading(true);
            let resp1;
            let resp2;
            let resp3;
            let resp4;
            let request1 = server.getConcernQueryMetrics(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, filters.time, customStart, customEnd, filters.team_name)
            let request2 = server.getDailyTrendConcernQuery(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, ['customers', 'open_concerns_and_queries'], filters.team_name)
            let request3 = server.getTopQueries(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, null, filters.team_name)
            let request4 = server.getTopConcerns(client_id, service_id, email, 'concerns-queries', undefined, filters.employee, filters.time, getAudioDurationValueForApi(), customStart, customEnd, null, filters.team_name)
            let [res1, res2, res3, res4] = await Promise.all([request1, request2, request3, request4])
            if(res1.status === 200){
                resp1 = await res1.json()
                resp2 = await res2.json()
                resp3 = await res3.json()
                resp4 = await res4.json()
                if(resp1.data){
                    const metricsData = resp1.data;
                    const transformedData = transformMetrics(metricsData)
                    setallMetrics(transformedData)
                    setActiveMetric(transformedData[0].id)
                }
                if(resp2.data){
                    setDailyTrendData(resp2.data)
                }
                if(resp3.data){
                    setTopQueries(resp3.data)
                }
                if(resp4.data){
                    setTopConcerns(resp4.data)
                }
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }
    }
    const getScoreBar = (score) => {
      let color = 'bg-green-500';
      let width = `${score}%`;
      
      
      
      return (
        <div className="w-16 bg-gray-200 rounded h-2">
          <div className={`h-2 rounded ${color}`} style={{ width }}></div>
        </div>
      );
    };

  // Sorting helpers for Top Concerns and Top Queries tables
  const getValueForSortCQ = (item, field) => {
    if (!item) return null;
    const v = item[field];
    if (v == null) return null;
    const num = Number(v);
    if (!Number.isNaN(num) && String(v).trim() !== '') return num;
    return String(v).toLowerCase();
  };

  const sortArrayCQ = (list, field, direction) => {
    if (!field || !direction) return list;
    const arr = [...list];
    const factor = direction === 'asc' ? 1 : -1;
    arr.sort((a, b) => {
      const va = getValueForSortCQ(a, field);
      const vb = getValueForSortCQ(b, field);
      if (va == null && vb == null) return 0;
      if (va == null) return 1; // nulls last
      if (vb == null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return factor * (va - vb);
      return factor * String(va).localeCompare(String(vb));
    });
    return arr;
  };

  const arrowClass = (cfg, field, dir) => (cfg.field === field && cfg.direction === dir ? 'text-indigo-600' : 'text-gray-300 group-hover:text-gray-400');
  const getAriaSort = (cfg, field) => (cfg.field === field ? (cfg.direction === 'asc' ? 'ascending' : 'descending') : 'none');
  const cycleSort = (cfg, setCfg, field) => {
    let nextDir = 'asc';
    if (cfg.field === field) {
      nextDir = cfg.direction === 'asc' ? 'desc' : (cfg.direction === 'desc' ? null : 'asc');
    }
    setCfg(nextDir ? { field, direction: nextDir } : { field: null, direction: null });
  };
  const renderArrows = (cfg, field, setCfg) => {
    if (cfg.field === field && cfg.direction === 'asc') {
      return (
        <ArrowUp className={`h-3 w-3 ${arrowClass(cfg, field, 'asc')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'asc' });}} />
      );
    }
    if (cfg.field === field && cfg.direction === 'desc') {
      return (
        <ArrowDown className={`h-3 w-3 -mt-0.5 ${arrowClass(cfg, field, 'desc')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'desc' });}} />
      );
    }
    return (
      <ChevronsUpDown className={`h-3 w-3 ${arrowClass(cfg, field, 'none')}`} onClick={(e)=>{e.stopPropagation(); setCfg({ field, direction: 'asc' });}} />
    );
  };
  const renderConcernsArrows = (field) => renderArrows(concernsSortConfig, field, setConcernsSortConfig);
  const renderQueriesArrows = (field) => renderArrows(queriesSortConfig, field, setQueriesSortConfig);

  const displayConcerns = useMemo(() => (
    concernsSortConfig.field ? sortArrayCQ(topConcerns, concernsSortConfig.field, concernsSortConfig.direction) : topConcerns
  ), [topConcerns, concernsSortConfig]);
  const displayQueries = useMemo(() => (
    queriesSortConfig.field ? sortArrayCQ(topQueries, queriesSortConfig.field, queriesSortConfig.direction) : topQueries
  ), [topQueries, queriesSortConfig]);
    const getFilterDetails = async () => {
            try {
              let res = await server.getAdvancedFilterDetailsAgentFeedback(client_id, service_id, email, 'concerns-queries', undefined)
              if(res.status === 200){
                let resp = await res.json()
                setMultiSelectFields(Array.isArray(resp.multiselects_list) ? resp.multiselects_list : []);
                setDummyFilterData(prev => ({
                  ...prev,
                  employees: resp.employee_id,
                  teams: resp.team_names || resp.team_name || resp.teams || []
              }));
              }
            } catch (error) {
            }
          }
    function getCookie(name) {
            function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
            return match ? match[1] : null;
    }
    useEffect(() => {
                    const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
                    if (user) {
                      setEmail(user.email);
                    }
                    if (serviceID) {
                      setService_id(serviceID);
                    }
                    if(clientID){
                      setClient_id(clientID)
                    }
                    if(role === 'employee'){
                      handleFilterChange({'target': {'value': user.name}}, 'employee')
                    }
                  }, [serviceID, clientID, role]);
                
    useEffect(() => {
                    if (client_id && service_id && email) {
                      getMetrics();
                      getFilterDetails();
                    }
                  }, [client_id, service_id, email]);
    useEffect(() => {
      if (!client_id || !service_id || !email) return;
      if (firstMetricsLoadRef.current) {
        firstMetricsLoadRef.current = false;
        return;
      }
      if (metricsDebounceRef.current) {
        clearTimeout(metricsDebounceRef.current);
      }
      metricsDebounceRef.current = setTimeout(() => {
        getMetrics();
      }, 600);
      return () => {
        if (metricsDebounceRef.current) {
          clearTimeout(metricsDebounceRef.current);
        }
      };
    }, [filters, customStart, customEnd, client_id, service_id, email]);
                  useEffect(() => {
                    const handleEsc = (event) => {
                      if (event.key === "Escape") {
                        setShowConversationPage(false);
                        setShowCustomerPage(false);
                        setSelectedSegment(null);
                        setFilters((prev) => stripDrilldownFilterKeys(prev));
                      }
                    }
                    if (showConversationPage || showCustomerPage) {
                      window.addEventListener('keydown', handleEsc);
                    }
                    return () => {
                      window.removeEventListener('keydown', handleEsc);
                    }
                  }, [showConversationPage, showCustomerPage])

          // Update URL whenever filters change
          useEffect(() => {
            if (!client_id || !service_id) return;
            
            const timeoutId = setTimeout(() => {
              updateUrlWithFilters(navigate, location, pickConcernsQuickFilters(filters), {}, customStart, customEnd);
            }, 300);
            
            return () => clearTimeout(timeoutId);
          }, [filters, customStart, customEnd, client_id, service_id]);
    return (
        <div className="py-3 px-5 font-sans bg-gray-50">
                    <h1 className="text-xl font-semibold text-gray-900 mb-2">Concerns & Queries</h1>
                    <div className="text-sm text-gray-500">Monitor customer concerns and queries</div>
                    <div className="pt-4 pl-4 bg-white rounded-lg shadow-sm p-4 mt-4">
                        <div className="text-sm font-medium text-gray-700 mb-4">Quick Filters</div>
                        <div className="flex gap-4 mb-2">
                                <ModernTimeDropdown placeholder="Select Team" value={filters.team_name} onChange={(e) => handleFilterChange(e, 'team_name')} options={dummyFilterData.teams} isMulti={isMultiSelectField('team_name')}/>
                                <ModernTimeDropdown isDisabled={role === 'employee'} placeholder="Select Employee" value={filters.employee} onChange={(e) => handleFilterChange(e, 'employee')} options={dummyFilterData.employees} isMulti={isMultiSelectField('employee')}/>
                                <ModernTimeDropdown placeholder="Select Time Duration" value={filters.time} onChange={(e) => handleFilterChange(e, 'time')} options={dummyFilterData.times} isMulti={isMultiSelectField('time')}/>
                                <ModernTimeDropdown placeholder="Select Audio Duration" value={filters.audioduration} onChange={(e) => handleFilterChange(e, 'audioduration')} options={dummyFilterData.audio_duration} isMulti={isMultiSelectField('audioduration')}/>
                                </div>
                                {filters.time === "Custom Range" && (
                                          <div className="mb-2">
                                            <ModernDateRangePicker
                                              startDate={customStart}
                                              endDate={customEnd}
                                              rangeType={filters.customRangeType || "between"}
                                              maxRangeDays={90}
                                              placeholder="Select Time Range"
                                              onChange={({ startDate, endDate, rangeType }) => {
                                                setCustomStart(startDate);
                                                setCustomEnd(endDate);
                                                setFilters((prev) => ({ ...prev, customRangeType: rangeType || "between" }));
                                              }}
                                            />
                                          </div>
                                        )}
                                {filters.audioduration === "Custom Range" && (
                                  <div className="flex gap-4 mb-2">
                                    <input
                                      type="number"
                                      min="0"
                                      value={filters.audioDurationLower ?? ''}
                                      onChange={(e) => handleFilterChange(e, 'audioDurationLower')}
                                      placeholder="Audio Duration Lower Limit (sec)"
                                      className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input"
                                    />
                                    <input
                                      type="number"
                                      min="0"
                                      value={filters.audioDurationUpper ?? ''}
                                      onChange={(e) => handleFilterChange(e, 'audioDurationUpper')}
                                      placeholder="Audio Duration Upper Limit (sec)"
                                      className="px-2 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none global-input"
                                    />
                                  </div>
                                )}
                        <div className="flex gap-4 mb-4 mt-4 flex-wrap">
                                                {CONCERNS_QUICK_FILTER_KEYS.map(
                                                  (key) =>{
                                                    if (key === 'customRangeType') {
                                                      return null;
                                                    }
                                                    if (key === 'time' && filters.time === 'Custom Range') {
                                                      return null;
                                                    }
                                                    if (key === 'audioDurationLower' || key === 'audioDurationUpper') {
                                                      return null;
                                                    }
                                                    if (key === 'audioduration' && filters.audioduration === 'Custom Range') {
                                                      return null;
                                                    }
                                                    return (Array.isArray(filters[key]) ? filters[key].length > 0 : filters[key]) && (
                                                      <div key={key} className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                                                        <span className="capitalize text-indigo-600">{key} - {Array.isArray(filters[key]) ? (filters[key].length > 2 ? `${filters[key].slice(0, 2).join(', ')} +${filters[key].length - 2} more` : filters[key].join(', ')) : filters[key]}</span>
                                                        {key!=='time' && !(role === 'employee' && key === 'employee') && <button
                                                          className="ml-2 text-gray-600"
                                                          onClick={() => setFilters((prev) => ({ ...prev, [key]: null }))}
                                                        >
                                                          <FaTimes />
                                                        </button>}
                                                      </div>
                                                    )
                                                  })}
                                                  {filters.time === "Custom Range" && customStart && (filters.customRangeType === "after" || customEnd) && (
                                                                                                                        <div className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                                                                                                                          <span className="text-indigo-600">
                                                                                                                            Time - {customStart} {filters.customRangeType === "after" ? "onwards" : `to ${customEnd}`}
                                                                                                                          </span>
                                                                                                                          <button
                                                                                                                            className="ml-2 text-gray-600"
                                                                                                                            onClick={() => {
                                                                                                                              setFilters((prev) => ({ ...prev, time: '', customRangeType: 'between' }));
                                                                                                                              setCustomStart('');
                                                                                                                              setCustomEnd('');
                                                                                                                            }}
                                                                                                                          >
                                                                                                                            <FaTimes />
                                                                                                                          </button>
                                                                                                                        </div>
                                                                                            )}
                                                                                            {filters.audioduration === "Custom Range" && filters.audioDurationLower !== '' && filters.audioDurationUpper !== '' && (
                                                                                                                        <div className="flex items-center bg-indigo-50 p-2 rounded" style={{fontSize: "0.6rem", lineHeight: "0.25rem"}}>
                                                                                                                          <span className="text-indigo-600">Audio Duration - {filters.audioDurationLower} to {filters.audioDurationUpper}</span>
                                                                                                                          <button
                                                                                                                            className="ml-2 text-gray-600"
                                                                                                                            onClick={() => setFilters((prev) => ({ ...prev, audioduration: '', audioDurationLower: '', audioDurationUpper: '' }))}
                                                                                                                          >
                                                                                                                            <FaTimes />
                                                                                                                          </button>
                                                                                                                        </div>
                                                                                            )}
                                          </div>
                    </div>
                    <div>
                        <div className="py-6 px-3 flex items-center">
                            <div style={{width: "100%", background: "white", height: "55vh"}}>
                            {
                                isLoading && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                                {!isLoading && <TrendsLineWithMetrics 
                                    data={dailyTrendData} 
                                    metrics={allmetrics} 
                                    activeMetric={activeMetric} 
                                    setActiveMetric={setActiveMetric}
                                    formatDate={formatDate}
                                    formatTime={formatTime}
                                    title=""
                                    width="w-full"
                                    calculatePercentChange={calculatePercentChange}
                                    useMetricTabs={true} setShowDetails={handleShowCustomers}
                                    defaultSmoothing='1'
                                />}
                            </div>
                        </div>
                    </div>
                    {/* Top Concerns and Queries */}
                    <div className="grid grid-cols-1 gap-6 mb-8">
                        {/* Top Concerns */}
                        <div className="bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="text-lg font-medium text-gray-700">Top Concerns</h3>
                            <button onClick={() => handleDownloadCSV('concerns')} className="flex items-center p-2 m-2"><Download className="ml-2" /></button>
                        </div>
                        <div className="p-4">
                            <div className="overflow-x-auto" style={{height: "65vh", overflowY: "auto"}}>
                            {
                                isLoading && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                            {!isLoading && <table className="min-w-full">
                                <thead>
                                <tr className="bg-gray-50 text-left">
                                    <th scope="col" aria-sort={getAriaSort(concernsSortConfig, 'Category')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider">
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(concernsSortConfig, setConcernsSortConfig, 'Category')}>
                                        <span>Category</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderConcernsArrows('Category')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(concernsSortConfig, 'Subcategory')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider">
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(concernsSortConfig, setConcernsSortConfig, 'Subcategory')}>
                                        <span>Subcategory</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderConcernsArrows('Subcategory')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(concernsSortConfig, 'Total Concerns')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(concernsSortConfig, setConcernsSortConfig, 'Total Concerns')}>
                                        <span>Total Concerns</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderConcernsArrows('Total Concerns')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(concernsSortConfig, 'Handled Concerns')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(concernsSortConfig, setConcernsSortConfig, 'Handled Concerns')}>
                                        <span>Handled Concerns</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderConcernsArrows('Handled Concerns')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(concernsSortConfig, 'Handled Percentage')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(concernsSortConfig, setConcernsSortConfig, 'Handled Percentage')}>
                                        <span>Handled Percentage</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderConcernsArrows('Handled Percentage')}</span>
                                      </button>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {displayConcerns.map((query, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 text-sm text-gray-900">{query['Category']}</td>
                                    <td className="px-4 py-3 text-sm text-gray-900">{query['Subcategory']}</td>
                                    <td className="px-4 py-3 text-sm font-medium cursor-pointer text-indigo-500 hover:text-indigo-700 underline text-center" onClick={() => handleConcernSubcategoryClick(query['Subcategory'], query['Category'])}>{query['Total Concerns']}</td>
                                    <td className="px-4 py-3 text-sm text-gray-900 text-center">{query['Handled Concerns']}</td>
                                    <td className="px-4 py-3">
                                        <div className="flex items-center justify-center">
                                        {getScoreBar(query['Handled Percentage'])}
                                        <span className="text-sm ml-2" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{Math.round(query['Handled Percentage'], 0)}</span>
                                        </div>
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>}
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-6 mb-8">
                        {/* Top Queries */}
                        <div className="bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
                            <h3 className="text-lg font-medium text-gray-700">Top Queries</h3>
                            <button onClick={() => handleDownloadCSV('queries')} className="flex items-center p-2 m-2"><Download className="ml-2" /></button>
                        </div>
                        <div className="p-4">
                            <div className="overflow-x-auto" style={{height: "65vh", overflowY: "auto"}}>
                            {
                                isLoading && (
                                    <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                                    <div className="loader"></div>
                                    <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                                    </div>
                                )
                                }
                            {!isLoading && <table className="min-w-full">
                                <thead>
                                <tr className="bg-gray-50 text-left">
                                    <th scope="col" aria-sort={getAriaSort(queriesSortConfig, 'Category')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider">
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(queriesSortConfig, setQueriesSortConfig, 'Category')}>
                                        <span>Category</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderQueriesArrows('Category')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(queriesSortConfig, 'Subcategory')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider">
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(queriesSortConfig, setQueriesSortConfig, 'Subcategory')}>
                                        <span>Subcategory</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderQueriesArrows('Subcategory')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(queriesSortConfig, 'Total Queries')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(queriesSortConfig, setQueriesSortConfig, 'Total Queries')}>
                                        <span>Total Queries</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderQueriesArrows('Total Queries')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(queriesSortConfig, 'Handled Queries')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(queriesSortConfig, setQueriesSortConfig, 'Handled Queries')}>
                                        <span>Handled Queries</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderQueriesArrows('Handled Queries')}</span>
                                      </button>
                                    </th>
                                    <th scope="col" aria-sort={getAriaSort(queriesSortConfig, 'Handled Percentage')} className="px-4 py-3 text-sm font-medium text-gray-700 uppercase tracking-wider" style={{textAlign: "center"}}>
                                      <button type="button" className="flex items-center group" onClick={()=>cycleSort(queriesSortConfig, setQueriesSortConfig, 'Handled Percentage')}>
                                        <span>Handled Percentage</span>
                                        <span className="ml-1 flex flex-col leading-none">{renderQueriesArrows('Handled Percentage')}</span>
                                      </button>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {displayQueries.map((query, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                    <td className="px-4 py-3 text-sm text-gray-900">{query['Category']}</td>
                                    <td className="px-4 py-3 text-sm text-gray-900">{query['Subcategory']}</td>
                                    <td className="px-4 py-3 text-sm font-medium cursor-pointer text-indigo-500 hover:text-indigo-700 underline text-center" onClick={() => handleQuerySubcategoryClick(query['Subcategory'], query['Category'])}>{query['Total Queries']}</td>
                                    <td className="px-4 py-3 text-sm text-gray-900 text-center">{query['Handled Queries']}</td>
                                    <td className="px-4 py-3">
                                        <div className="flex items-center justify-center">
                                        {getScoreBar(query['Handled Percentage'])}
                                        <span className="text-sm ml-2" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{Math.round(query['Handled Percentage'], 0)}</span>
                                        </div>
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>}
                            </div>
                        </div>
                        </div>
                    </div>
                    {
                showConversationPage && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationPage(false); setSelectedSegment(null); setFilters((prev) => stripDrilldownFilterKeys(prev));}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
                              <ConversationRecords segment={selectedSegment} serviceID={service_id} type="modal-open" clientID={client_id}/>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                showCustomerPage && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "5px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowCustomerPage(false); setSelectedSegment(null); setFilters((prev) => stripDrilldownFilterKeys(prev));}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%"}}>
                              <CustomerRecords segment={selectedSegment} serviceID={service_id} type="modal-open" clientID={client_id}/>
                            </div>
                        </div>
                    </div>
                )
            }
                    </div>
    )
}

export default ConcernQueries;
